<!--
  Single-file (invoice) variant of the redesigned file upload. Either a
  file chip (with a trash button) OR the dropzone is shown — never both
  — so dealers don't see "Ni naloženih datotek" + dropzone + "No file
  chosen" stacked together for an empty field.
-->
<div class="briefd-files">
  <div *ngIf="file?.upload" class="briefd-files__list">
    <div class="briefd-files__item">
      <i class="fas fa-file briefd-files__item-icon"></i>
      <a [href]="file.upload.files[0].url + '?download=1'"
         [title]="file.upload.files[0].fileName"
         target="_blank"
         class="briefd-files__item-name">
        {{ file.upload.files[0].fileName }}
      </a>
      <span class="briefd-files__item-size">
        {{ (file.upload.files[0].size / 1000000).toFixed(2) | number }} MB
      </span>
      <button (click)="removeFile()" type="button"
              class="briefd-files__item-remove"
              [attr.aria-label]="'Odstrani datoteko'" i18n-aria-label>
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
  </div>

  <div *ngIf="file && !file.upload" class="briefd-files__list">
    <div class="briefd-files__item">
      <i class="fas fa-spinner fa-spin briefd-files__item-icon"></i>
      <span class="briefd-files__item-name briefd-files__item-name--loading"
            i18n="Loading text for file upload">Datoteka se nalaga...</span>
    </div>
  </div>

  <!-- Dropzone hidden once a file is uploaded — the field accepts a
       single file, so the trash button on the chip is the path to
       replacing it. -->
  <div *ngIf="!file?.upload"
       ngx-dropzone (change)="onSelect($event)" [multiple]="false"
       [attr.data-field]="field?.fieldUuid"
       [attr.data-typeId]="field?.config?.typeId"
       [maxFileSize]="(field?.config?.maxFileSize || 20480) * 1024"
       class="briefd-files__dropzone">
    <ngx-dropzone-label class="briefd-files__dropzone-label">
      <i class="fas fa-cloud-upload-alt briefd-files__dropzone-icon"></i>
      <span class="briefd-files__dropzone-text">
        <span class="briefd-files__dropzone-cta" i18n>Dodaj datoteko</span>
        <span class="briefd-files__dropzone-hint" i18n>ali odloži datoteko sem</span>
      </span>
    </ngx-dropzone-label>
  </div>

  <p class="briefd-files__size-hint">
    <i class="fas fa-info-circle"></i>
    <span i18n="file input">Največja dovoljena velikost datoteke je</span>
    {{ (field?.config?.maxFileSize || 20480) / 1024 | number:'1.0-0' }} MB
  </p>
</div>
